<template>
    <v-container fluid grid-list-sm>
        <v-row>
            <v-col cols="12" sm="9">
                <h3 class="display-1 primary--text">Customers</h3>
            </v-col>
            <v-col cols="12" sm="3">
                <v-btn @click="createCustomer" x-large class="float-right" color="primary" fab icon><v-icon>mdi-pencil</v-icon></v-btn>
            </v-col>
            <v-col cols="12" sm="3">
                <v-text-field v-on:click:clear="clearSearch" :loading="isLoading" v-debounce:500ms="searchForCustomer" label="Search for customer" v-model="search" clearable />
            </v-col>
            <v-col cols="12" sm="12">
                <v-data-table :loading="isLoading" :headers="headers" :items="c" class="elevation-1 mt-5">
                    <template v-slot:item.actions="{item}">
                        <v-icon color="secondary" class="mr-2" @click="createBooking(item)">mdi-calendar</v-icon>
                        <v-icon color="error" class="mr-2" @click="launchDeleteDialog(item)">mdi-delete</v-icon>
                        <v-icon color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    export default {
        name: "Customers",
        computed: {
            ...mapState("customers", ["customers"]),
            c: {
                get() {
                    return this.customers;
                }
            }
        },
        methods: {
            ...mapActions("customers", ["setActiveCustomer", "setManageCustomerDialog", "setCustomers", "filterCustomers", "setDeleteCustomerDialog"]),
            ...mapActions("bookings", ["setManageBookingDialog", "setActiveBooking"]),
            async editItem(item) {
                await this.setActiveCustomer(item);
                await this.setManageCustomerDialog(true);
            },
            async createCustomer() {
                await this.setActiveCustomer({});
                await this.setManageCustomerDialog(true);
            },
            async createBooking(item) {
                await this.setActiveBooking({startDate: new Date(), endDate: new Date(), isXeroBooking: true, customer: item, isNewBookingSystem: true});
                await this.setManageBookingDialog(true);
            },
            clearSearch() {
                this.setCustomers();
            },
            async searchForCustomer() {
                if (this.search.length > 3) {
                    this.isLoading = true;
                    await this.filterCustomers(this.search);
                    this.isLoading = false;
                }
            },
            async launchDeleteDialog(item) {
              await this.setActiveCustomer(item);
              await this.setDeleteCustomerDialog(true);
            }
        },
        data() {
            return {
                isLoading: false,
                search: '',
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Email', value: 'email' },
                    { text: 'Phone', value: 'phone' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
